import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { Col, Form, Input, Modal, Row, Select } from 'antd';
import React, { useState } from 'react';
import CustomButton from '../../../../../../../v2-components/Antd/Button';

const STATIC_CONTENT = {
  CONCENTRATION_UNIT: [
    '%',
    '% en crema', 
    'gr',
    'mcg',
    'mg',
    'mg/cápsula',
    'mg/ml', 
    'mg/sachet',
    'UI',
  ]
};

const ModalNewComponent = ({ onSave, onCancel }) => {
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);

  const handlePost = async () => {
    if (!name.trim()) return;
    setLoading(true);

    try {
      const newComponent = await onSave(name);
      Modal.success({ content: `Componente '${newComponent.name}' agregado.` });
      onCancel();
    } catch (error) {
      Modal.error({ content: 'Error al agregar componente.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form layout="vertical">
      <Form.Item label="Nombre del Nuevo Componente" required>
        <Input value={name} onChange={(e) => setName(e.target.value)} />
      </Form.Item>
      <CustomButton type="primary" loading={loading} onClick={handlePost}>
        Guardar Componente
      </CustomButton>
    </Form>
  );
};


/**
 * Componente que representa una fila editable de Componente, Concentración y Unidad.
 * @param {object} componentData - El objeto de datos de la fila actual.
 * @param {boolean} canDelete - Si es true, el botón de eliminar se muestra.
 * @param {array} apiComponentOptions - Opciones dinámicas de la API.
 * @param {function} onChange - Callback para actualizar el array de componentes.
 * @param {function} onRemove - Callback para eliminar la fila.
 * @param {function} onNewComponentPost - Callback para hacer POST de un nuevo componente.
 */
export function MagistralComponentModule({
  componentData,
  canDelete,
  apiComponentOptions,
  onChange,
  onRemove,
  onNewComponentPost
}) {
  const [isModalVisible, setIsModalVisible] = useState(false);

  // const concentrationOptions = STATIC_CONTENT.CONCENTRATION.map(v => ({ label: String(v), value: v }));
  const unitOptions = STATIC_CONTENT.CONCENTRATION_UNIT.map(v => ({ label: v, value: v }));
  const componentOptions = apiComponentOptions.map(c => ({ label: c.name, value: c.id }));

  const handleFieldChange = (field, value) => {
    onChange(componentData.id, field, value);
  };

  return (
    <Row gutter={8} align="bottom" style={{ marginBottom: 12 }}>

      <Col span={10}>
        <Form.Item label="Componente" required>
          <Select
            showSearch
            filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
            placeholder="Seleccionar Componente"
            value={componentData.component_id}
            options={componentOptions}
            onChange={(value) => handleFieldChange('component_id', value)}

          />
        </Form.Item>
      </Col>

      <Col span={2}>
        <Form.Item label="&nbsp;">
          <CustomButton
            icon={<PlusOutlined />}
            type="secondary"
            style={{ width: '100%', padding: '4px 8px' }}
            onClick={() => setIsModalVisible(true)}
          >
          </CustomButton>
        </Form.Item>
      </Col>

      <Col span={5}>
        <Form.Item label="Concentración" required>
          <Input
            placeholder="Valor"
            value={componentData.concentration_value}
            // options={concentrationOptions}
            onChange={(e) => handleFieldChange('concentration_value', e.target.value)}
            type="number"
          />
        </Form.Item>
      </Col>

      <Col span={5}>
        <Form.Item label="Unidad de Medida" required>
          <Select
            placeholder="Unidad"
            value={componentData.concentration_unit}
            options={unitOptions}
            onChange={(value) => handleFieldChange('concentration_unit', value)}
          />
        </Form.Item>
      </Col>

      <Col span={2}>
        <Form.Item label="&nbsp;">
          <CustomButton
            icon={<DeleteOutlined />}
            danger
            disabled={!canDelete}
            onClick={() => onRemove(componentData.id)}
          />
        </Form.Item>
      </Col>

      <Modal
        title="Nuevo Componente Magistral"
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
      >
        <ModalNewComponent onSave={onNewComponentPost} onCancel={() => setIsModalVisible(false)} />
      </Modal>
    </Row>
  );
}